import { type Layout, type PlotData } from 'plotly.js';
import React from 'react';

import PlotWrapper from './PlotWrapper';
import PageModuleTitle from './layout/PageModuleTitle';

export interface GenericPlotProps {
  data: Array<Partial<PlotData>>;
  layout?: Partial<Layout>;
  modalTitle: string;
  excludeHeader?: boolean;
}

/**
 * @deprecated Use CPageModulePlot.
 * @param data
 * @param layout
 * @param modalTitle
 * @param excludeHeader
 * @constructor
 */
export default function GenericPlot({ data, layout, modalTitle, excludeHeader }: GenericPlotProps) {
  return (
    <div className="flex flex-col gap-6">
      {!excludeHeader && <PageModuleTitle level={'h2'}>{modalTitle}</PageModuleTitle>}
      <PlotWrapper data={data} layout={layout} modalTitle={modalTitle} />
    </div>
  );
}
